import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  picturesSection: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    width: "100%",
    direction: "rtl",
  },
  dragHint: {
    width: "100%",
    paddingTop: 16,
    opacity: 1,
  },
  dragHintActive: {
    backgroundColor: theme.palette.action.hover,
    borderRadius: 6,
  },
  dragHintText: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 42,
    width: "100%",
    margin: 0,
    fontFamily: theme.typography.fontFamily,
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "21px",
    color: theme.palette.text.primary,
    textAlign: "center",
    cursor: "pointer",
    userSelect: "none",
  },
  hiddenFileInput: {
    display: "none",
  },
  picturesGrid: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-end",
    gap: 16,
    width: "100%",
    direction: "rtl",
  },
  pictureCard: {
    display: "flex",
    flexDirection: "column",
    width: 223.25,
    height: 200,
    boxSizing: "border-box",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 6,
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
    opacity: 1,
  },
  picturePreview: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
    minHeight: 0,
    backgroundColor: theme.palette.grey[400],
  },
  picturePlaceholderIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 56,
    height: 56,
    borderRadius: 8,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    "& .MuiSvgIcon-root": {
      fontSize: 32,
    },
  },
  pictureInfo: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexShrink: 0,
    width: "100%",
    height: 49,
    boxSizing: "border-box",
    gap: 6,
    padding: 10,
    borderTop: `1px solid ${theme.palette.divider}`,
    opacity: 1,
    direction: "rtl",
  },
  pictureMeta: {
    display: "flex",
    flexDirection: "column",
    gap: 6,
    minWidth: 0,
    flex: 1,
  },
  pictureFileName: {
    fontFamily: theme.typography.fontFamily,
    fontSize: "14px",
    fontWeight: 400,
    fontStyle: "normal",
    lineHeight: "21px",
    letterSpacing: 0,
    color: theme.palette.secondary.main,
    textAlign: "right",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  pictureDate: {
    fontFamily: theme.typography.fontFamily,
    fontSize: "12px",
    fontWeight: 400,
    fontStyle: "normal",
    lineHeight: "18px",
    letterSpacing: 0,
    color: theme.palette.text.primary,
    textAlign: "right",
  },
  pictureAvatar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    width: 25,
    height: 25,
    borderRadius: "50%",
    backgroundColor: "#F4C430",
    fontFamily: theme.typography.fontFamily,
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: 1,
    color: theme.palette.common.black,
  },
}));
